import styled from 'styled-components';

interface IProps {
  className?: string;
}

export const Skeleton = styled.div<IProps>`
  width: 100%;
  height: 20px;
  background-color: #f6f6f6;
`;
